module.exports = __webpack_public_path__ + "static/media/admin.75f4da58.png";